import { Building2, Cloud, Database, Network, UsersRound } from 'lucide-react'
import { useState } from 'react'

const nodes = [
  { id: 'business', label: 'Business', icon: Building2 },
  { id: 'people', label: 'People', icon: UsersRound },
  { id: 'cloud', label: 'Cloud', icon: Cloud },
  { id: 'network', label: 'Network', icon: Network },
  { id: 'data', label: 'Data', icon: Database },
]

export function InteractiveSystemMap() {
  const [active, setActive] = useState('business')

  return (
    <div className="system-map" data-active={active} aria-label="Connected business systems">
      <svg className="system-map__lines" viewBox="0 0 680 520" aria-hidden="true">
        <path d="M340 260 148 148M340 260 340 72M340 260 536 150M340 260 525 390M340 260 155 390" />
        <path d="M148 148 155 390M340 72 536 150M536 150 525 390M525 390 155 390" />
      </svg>
      <div className="system-map__core" aria-hidden="true">
        <span />
        <span />
        <span />
      </div>
      {nodes.map(({ id, label, icon: Icon }) => (
        <button
          type="button"
          className={`system-map__node system-map__node--${id}`}
          key={id}
          aria-pressed={active === id}
          onMouseEnter={() => setActive(id)}
          onFocus={() => setActive(id)}
          onClick={() => setActive(id)}
        >
          <Icon aria-hidden="true" strokeWidth={1.2} />
          <span>{label}</span>
        </button>
      ))}
      <div className="system-map__hint">Explore the connected environment</div>
    </div>
  )
}
